import { conditionsReducerKey, CONDITIONS_DEFAULT_SORT, CONDITIONS_DEFAULT_TOTAL_PAGES, CONDITIONS_PAGE_SIZE } from './constants';
import { initialState } from './reducer';
import { DEFAULT_SORT_BY, DEFAULT_SORT_ORDER, EMPTY_SUMMARY } from './components/conditionsDetailConstants';

export const getConditionsState = (state) => state?.get?.(conditionsReducerKey) || initialState;

export const getConditionsRuns = (state) => getConditionsState(state).runs || [];
export const getConditionsSort = (state) => getConditionsState(state).sort || CONDITIONS_DEFAULT_SORT;
export const getConditionsSelectedIds = (state) => getConditionsState(state).selectedIds || [];
export const getConditionsAnnouncement = (state) => getConditionsState(state).announcement || '';
export const getConditionsError = (state) => getConditionsState(state).error || '';
export const getConditionsIsLoading = (state) => Boolean(getConditionsState(state).isLoading);
export const getConditionsProjectsHasSettledOnce = (state) => Boolean(getConditionsState(state).projectsHasSettledOnce);
export const getConditionsPage = (state) => getConditionsState(state).page || 0;
export const getConditionsPageSize = (state) => getConditionsState(state).pageSize || CONDITIONS_PAGE_SIZE;
export const getConditionsTotalItems = (state) => getConditionsState(state).totalItems || 0;
export const getConditionsTotalPages = (state) => getConditionsState(state).totalPages || CONDITIONS_DEFAULT_TOTAL_PAGES;
const getConditionsDetail = (state, projectId) => {
  const conditionsState = getConditionsState(state);
  const detailProjectId = projectId || conditionsState.detailCurrentProjectId;
  return conditionsState.detailByProjectId?.[detailProjectId] || null;
};
export const getConditionsDetailRun = (state, projectId) => getConditionsDetail(state, projectId)?.run || null;
export const getConditionsDetailRecommendations = (state, projectId) => getConditionsDetail(state, projectId)?.recommendations || [];
export const getConditionsDetailSummary = (state, projectId) => getConditionsDetail(state, projectId)?.summary || EMPTY_SUMMARY;
export const getConditionsDetailIsLoading = (state) => Boolean(getConditionsState(state).detailIsLoading);
export const getConditionsDetailHasSettled = (state, projectId) =>
  Boolean(getConditionsState(state).detailHasSettledByProjectId?.[projectId]);
export const getConditionsDetailError = (state) => getConditionsState(state).detailError || '';
const getConditionsDetailSort = (state, projectId) => {
  const conditionsState = getConditionsState(state);
  const sortProjectId = projectId || conditionsState.detailCurrentProjectId;
  return conditionsState.detailSortByProjectId?.[sortProjectId] || {};
};
export const getConditionsDetailSortBy = (state, projectId) => getConditionsDetailSort(state, projectId).sortBy || DEFAULT_SORT_BY;
export const getConditionsDetailSortOrder = (state, projectId) => getConditionsDetailSort(state, projectId).sortOrder || DEFAULT_SORT_ORDER;
export const getConditionsNavigatorRestoration = (state) => getConditionsState(state).navigatorRestoration;
export const getConditionsDetailRestoration = (state) => getConditionsState(state).detailRestoration;
